import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/_components/Shared/Faq/index.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/privacy/index.module.scss");
